import React from "react";
import FormattedObject from "@/models/interfaces/viewer/formatted-object.ts";
import ViewerItemsSelectionChangedModel from "./models/viewer-items-selection-changed-model.ts";

export interface ViewerItemsSelectionContextProps {
    selectedItems: FormattedObject[];
    subscribeSelectionChanged: (callback: (model: ViewerItemsSelectionChangedModel) => void) => void;
    
    addItem: (item: FormattedObject) => void;
    removeItem: (item: FormattedObject) => void;
    clearSelection: () => void;
}

export const ViewerItemsSelectionContext = React.createContext<ViewerItemsSelectionContextProps | undefined>(undefined);